export const USER_LICENSES = {
  LOADMASTER_IMAGING_RUN_IMAGING_PROGRAM:
    "com.tms.client.loadmaster.imaging.RunImagingProgram"
};
